module.exports = (parcelRequire.load("lsXP2")).then(() => parcelRequire('9RV17'));